import { Grid, Card, Typography, Backdrop, CircularProgress } from "@mui/material";
import MDButton from "components/MDButton";
import { useForm } from 'react-hook-form';
import MDBox from "components/MDBox";
import { TextField, TextareaAutosize } from '@mui/material';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';
import { handleErrors } from "common.js";
import configurations from "config";
import MDInput from "components/MDInput";
import { convertToBase64 } from "common";
import { IconButton, Icon } from "@mui/material";

export default function CreateTicket(props) {
    const { newTicket } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const baseUrl = configurations.baseUrl;
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;

    const { register, handleSubmit, formState: { errors }, setValue, getValues } = useForm();

    const onSubmit = async (data) => {
        setIsLoading(true);
        axios.post(baseUrl + '/ticket/create', data, {
            headers: {
                Authorization: bearerToken,
                function: azureFunctionVendorFrontendKey,
            }
        })
            .then((response) => {
                setIsLoading(false)
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                        const redirectTimeout = setTimeout(() => {
                            props.changeTicket();
                            clearTimeout(redirectTimeout);
                            navigate('/tickets/list/#ticketManage');
                        }, 3000);
                    }
                    else {
                        if (message != '')
                            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                        if (response && response.data && response.data.errors) {
                            const errorData = response.data.errors;
                            errorData.forEach((error) => {
                                setError(error.field, {
                                    type: 'server',
                                    message: t(error.errors[0])
                                });
                            });
                        }
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
                }
            }).catch(error => {
                setIsLoading(false)
                handleErrors(error, t, navigate);
            });

    };

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        const fileName = file.name;

        if (file) {
            const base64 = await convertToBase64(file);
            const fileData = { imageData: base64, name: fileName };
            setIsLoading(true);
            axios.post(baseUrl + '/ticket/create-ticket-attachment', fileData, {
                headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
            })
                .then((response) => {
                    setIsLoading(false);
                    if (response.status == 200) {
                        const status = response.data.status;
                        const message = response.data.message;
                        if (status == 1) {
                            let imageInfo = response.data.data;
                            imageInfo.fileName = fileName;
                            setValue('images', JSON.stringify([imageInfo]));
                            toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                        }
                        else {
                            if (message != '') {
                                setValue('images', '');
                                toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                            }
                        }
                    }
                    else {
                        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
                    }
                })
                .catch(error => {
                    setIsLoading(false);
                    handleErrors(error, t, navigate);
                });
        }
    }

    const handleFileDelete = async (e) => {
        let fileInfo = JSON.parse(getValues('images'))[0]
        const fileData = { azureImageId: fileInfo.azureImageId, mediaURL: fileInfo.mediaURL };
        setIsLoading(true);
        axios.post(baseUrl + '/ticket/delete-ticket-attachment', fileData, {
            headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
        })
            .then((response) => {
                setIsLoading(false)
                if (response.status == 200) {
                    const status = response.data.status;
                    const message = response.data.message;
                    if (status == 1) {
                        setValue('images', '');
                        toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                    }
                    else {
                        if (message != '')
                            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                    }
                }
                else {
                    toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
                }
            }).catch(error => {
                setIsLoading(false)
                handleErrors(error, t, navigate);
            });
    }

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
            <Card className="cardBottom" >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <MDBox mx={2} pt={3}>
                        <Grid container spacing={2} >
                            <Grid item xs={12} md={3}>
                                <Typography variant="h5">{t('postYourTicket')}</Typography>
                            </Grid>
                            <Grid item xs={12} md={9}>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <label className="fontSize14">{t('ticketTitle')}</label>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    {...register('subject', { required: { value: true, message: t('subjectRequired') } })}
                                    placeholder={t('enterTicketTitleHere')}
                                />
                                {errors.subject && <span className="errorMsg FloatRight">{t(errors.subject.message)}</span>}
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <label className="fontSize14">{t('ticketMessage')}</label>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <TextareaAutosize
                                    className="createTextArea"
                                    minRows={3}
                                    maxRows={6}
                                    placeholder={t('enterTicketMessageHere')}
                                    {...register('content', { required: { value: true, message: t('contentCannotBeEmpty') } })}
                                />
                                {errors.content && <span className="errorMsg FloatRight">{t(errors.content.message)}</span>}
                            </Grid>
                            <Grid item xs={12} md={3}></Grid>
                            <Grid item xs={12} md={9}>
                                {getValues('images') ?
                                    <>
                                        <MDBox component="img" src={JSON.parse(getValues('images'))[0].mediaURL} className="customFieldImage" />
                                        <IconButton
                                            className="PositionAbsolute"
                                            size="small"
                                            disableRipple
                                            variant="contained"
                                            onClick={(e) => { handleFileDelete(e) }}
                                        >
                                            <Icon className="closeIcon">close</Icon>
                                        </IconButton>
                                    </>
                                    :
                                    <MDInput
                                        type="file"
                                        name="image"
                                        InputProps={{
                                            classes: { root: "inputBoxStyle replyFile" },
                                        }}
                                        onChange={((e) => {
                                            e.stopPropagation()
                                            const file = e.target.files[0];
                                            if (file) {
                                                handleFileUpload(e);
                                            }
                                        })}
                                        fullWidth />
                                }

                                {errors.images && (<span className="errorMsg FloatRight">{errors.images.message}</span>)}
                            </Grid>
                            <Grid item xs={12} md={3}>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <MDButton variant="contained" color="primary" type="submit" disableRipple>{t('post')}</MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </form>
            </Card>
        </>
    );
}
